import type { SdkApiType } from "./sdkApi";

/** 主应用提供给 qiankun 子应用的 Host 能力契约 */
export interface HostBridge {
  /** SDK 就绪（单例，可重复 await） */
  getSdkApi(): Promise<SdkApiType>;
  /** 同步快照；未加载时返回 null */
  getSdkApiSync(): SdkApiType | null;
  /** 进入子应用路由前确保 Host 侧资源就绪 */
  whenRouteReady(appName: string): Promise<void>;
}

export const SDK_API_READY_EVENT = "sdkApiReady";
